/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Modal, Loader } from 'semantic-ui-react';
import cx from 'classnames';
import { withTranslation } from 'react-i18next';
import api from '../../api';
import ClarLoader from '../Loader/Loader';
import progress from '../../images/icons/progress_ica.gif';
import WithRouter from '../Extensions/WithRouter';
import './SystemSettings.css';

class SMTPSystem extends Component {
  constructor(props) {
    super(props);
    this.modalBody = null;
    this.state = {
      useSMTP: 'off',
      isSendEmailModal: false,
      isModalOpen: false,
      isIpSaving: false,
      isSmtpLoading: false,
      isAddrLoading: false,
      //baseUrl: '',
      checkMsg: '',
      serverURL: '',
      //protocol: 'http://',
      isModalLoader: false,
      cEmailError: '',
      modalAlertMsg: '',
      modalAlertTitle: '',
      baseUrlError: false,
      modalAlert: false,
      nickNameError: false,
      passwordError: false,
      addressError: false,
      domainError: false,
      hostError: false,
      portError: false,
      isPageLoading: false,
    };
    this.changeProtocol = this.changeProtocol.bind(this);
    this.handleUseSMTP = this.handleUseSMTP.bind(this);
    this.handleBaseUrlChange = this.handleBaseUrlChange.bind(this);
    this.handleSendEmail = this.handleSendEmail.bind(this);
    this.sendEmail = this.sendEmail.bind(this);
    this.serverAddress = this.serverAddress.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.saveEmailInfo = this.saveEmailInfo.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleNickNameChange = this.handleNickNameChange.bind(this);
    this.handlePWChange = this.handlePWChange.bind(this);
    this.handleAddressChange = this.handleAddressChange.bind(this);
    this.handleDomainChange = this.handleDomainChange.bind(this);
    this.handleHostChange = this.handleHostChange.bind(this);
    this.handlePortChange = this.handlePortChange.bind(this);
    this.handleAuthenticationChange = this.handleAuthenticationChange.bind(this);
    this.handleEnableStarttlsAutoChange = this.handleEnableStarttlsAutoChange.bind(this);
    this.handleCloseAlert = this.handleCloseAlert.bind(this);
    this.handleRevert = this.handleRevert.bind(this);
    this.validation = this.validation.bind(this);
  }

  componentDidMount() {
    this.onUpdateLoading();
  }

  componentDidUpdate(prevProps, prevState) {
    const { isPageLoading } = this.state;
    const { location } = this.props;

    if (prevState.isPageLoading !== isPageLoading && isPageLoading) {
      this.getSMTP();
      this.getServerAddress();
      this.setState({
        isPageLoading: false,
      });
    }

    if (prevProps.location && location) {
      const currentPath = location.pathname ? location.pathname : location;
      const prevPath = prevProps.location.pathname ? prevProps.location.pathname : prevProps.location;
      if (currentPath !== prevPath) {
        this.requiredAdmin();
      }
    }
  }

  handleBaseUrlChange(e) {
    const str = e.target.value.replace(/\/+$/, '');
    this.props.state.company.setBaseUrl(str);
  }

  handleSendEmail() {
    const { t } = this.props;
    if (this.baseUrl.value.trim() === '') {
      this.setState({
        checkMsg: t('modal.error.ip_address_required'),
        isIpSaving: false,
      });
      return false;
    }

    if (!this.validation()) return;

    this.setState({
      isSendEmailModal: true,
      cEmailError: '',
    });
  }

  handleUseSMTP(e) {
    const { value } = e.target;
    this.setState({
      useSMTP: value,
    });
  }

  handleRevert() {
    this.getSMTP();
  }

  handleCloseAlert() {
    this.setState({ modalAlert: false });
  }

  handleSave() {
    const { t } = this.props;
    const { useSMTP } = this.state;
    if (!this.validation()) {
      return;
    }

    if (useSMTP === 'on') {
      this.modalBody = t('system.message.save_smtp_settings');
    } else {
      this.modalBody = t('system.message.turn_off_smtp');
    }

    this.setState({
      isModalOpen: true,
    });
  }

  handleNickNameChange(event) {
    this.props.state.company.setNickName(event.target.value);
    this.setState({
      nickNameError: false,
    });
  }

  handlePWChange(event) {
    this.props.state.company.setPassword(event.target.value);
    this.setState({
      passwordError: false,
    });
  }

  handleAddressChange(event) {
    this.props.state.company.setAddress(event.target.value);
    this.setState({
      addressError: false,
    });
  }

  handleDomainChange(event) {
    this.props.state.company.setDomain(event.target.value);
    this.setState({
      domainError: false,
    });
  }

  handleHostChange(event) {
    this.props.state.company.setHost(event.target.value);
    this.setState({
      hostError: false,
    });
  }

  handlePortChange(event) {
    this.props.state.company.setPort(event.target.value);
    this.setState({
      portError: false,
    });
  }

  handleAuthenticationChange(event) {
    this.props.state.company.setAuthentication(event.target.value);

    if (event.target.value === 'none') {
      this.username.disabled = true;
      this.password.disabled = true;
    } else {
      this.username.disabled = false;
      this.password.disabled = false;
    }
  }

  handleEnableStarttlsAutoChange(event) {
    this.props.state.company.setEnableStarttlsAuto(event.target.value);
  }

  onUpdateLoading() {
    this.setState({
      isPageLoading: true,
    });
  }

  getSMTP() {
    this.setState({
      isSmtpLoading: true,
    }, () => {
      api
        .getCompanyDetail()
        .then((response) => {
          const data = response.response;
          this.props.state.company.saveEmailData(data.email_set);
          if (data.use_real_smtp) {
            this.setState({
              useSMTP: 'on',
              isSmtpLoading: false,
            });
          } else {
            this.setState({
              useSMTP: 'off',
              isSmtpLoading: false,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isSmtpLoading: false,
          });
        });
    });
  }

  getServerAddress() {
    this.setState({
      isAddrLoading: true,
    }, () => {
      api
        .getServerAddress()
        .then((response) => {
          if (response.response.ip) {
            const ipArr = response.response.ip.split('://');
            this.props.state.company.setProtocol(ipArr[0].concat('://'));
            this.props.state.company.setBaseUrl(ipArr[1]);
            this.setState({
              isAddrLoading: false,
              serverURL: ipArr[1],
            });
          } else {
            console.log('IP Address is NULL');
            this.setState({
              isAddrLoading: false,
              serverURL: '',
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isAddrLoading: false,
          });
        });
    });
  }

  updateSmtp(value) {
    const data = {
      use_smtp: value,
    };

    this.setState({
      isModalLoader: true,
    }, () => {
      api
        .useSmtp(data)
        .then((response) => {
          const res = response.response;
          if (!res.use_smtp) {
            this.props.state.company.nickName = '';
            this.props.state.company.password = '';
            this.props.state.company.address = '';
            this.props.state.company.domain = '';
            this.props.state.company.host = '';
            this.props.state.company.port = '';
            this.setState({
              isModalLoader: false,
              isModalOpen: false,
              baseUrlError: false,
              modalAlert: false,
              nickNameError: false,
              passwordError: false,
              addressError: false,
              domainError: false,
              hostError: false,
              portError: false,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isModalLoader: false,
          //isModalOpen: false,
          });
        });
    });
  }

  requiredAdmin() {
    const { state, navigate } = this.props;
    if (!state.user.isAdmin) {
      if (localStorage.getItem('main_page') === 'dashboard') {
        navigate('/main', { replace: true });
      } else if (localStorage.getItem('main_page') === 'results') {
        navigate('/results', { replace: true });
      } else {
        navigate(`/results/${this.props.state.user.main_page}`, { replace: true });
      }
    }
  }

  closeModal(e) {
    if (e.target.classList[0] === 'right_button') {
      return;
    }
    this.setState({
      isSendEmailModal: false,
      isModalOpen: false,
    });
  }

  changeProtocol(e) {
    this.props.state.company.setProtocol(e.target.value);
  }

  serverAddress() {
    const { t } = this.props;
    this.setState({
      isIpSaving: true,
      baseUrlError: false,
    });

    if (this.baseUrl.value.trim() === '') {
      this.setState({
        checkMsg: t('modal.error.ip_address_required'),
        isIpSaving: false,
        baseUrlError: true,
      });
      return false;
    }

    const data = {
      address: this.protocol.value.concat(this.baseUrl.value),
    };

    let interval = null;

    api
      .serverAddress(data)
      .then(() => {
        interval = setInterval(() => {
          api
            .getServerAddress()
            .then((res) => {
              if (res.response.ip === 'changing') {
                this.setState({
                  checkMsg: t('modal.error.progress'),
                  isIpSaving: false,
                  baseUrlError: true,
                });
              } else if (res.response.ip !== data.address) {
                this.setState({
                  checkMsg: t('modal.error.failed'),
                  isIpSaving: false,
                  baseUrlError: true,
                });
                clearInterval(interval);
              } else if (res.response.ip === data.address) {
                this.setState({
                  checkMsg: t('modal.error.verified'),
                  isIpSaving: false,
                  baseUrlError: true,
                  serverURL: this.baseUrl.value,
                });
                clearInterval(interval);
              }
            });
        }, 500);
      });
  }

  sendEmail() {
    const { t } = this.props;
    if (this.baseUrl.value.trim() === '') {
      this.setState({
        checkMsg: t('modal.error.ip_address_required'),
        isIpSaving: false,
      });
      return false;
    }

    const data = {
      from: this.from.value,
      to: this.to.value,
      domain: this.domain.value,
      address: this.host.value,
      port: Number(this.port.value),
      authentication: this.authentication.value,
      enable_starttls_auto: this.enableStarttlsAuto.value === 'true',
    };

    if (data.authentication !== 'none') {
      data.username = this.username.value;
      data.password = this.password.value;
    }

    if (!this.validation()) {
      return;
    }

    this.setState({
      isModalLoader: true,
    }, () => {
      api
        .mailer(data)
        .then(() => {
          this.setState({
            isModalLoader: false,
            isSendEmailModal: false,
            modalAlert: true,
            modalAlertTitle: t('modal.title.notice'),
            modalAlertMsg: t('system.message.sent_email'),
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;

          if (o.error_description) {
            this.setState({
              isModalLoader: false,
              cEmailError: o.error_description,
            });
          } else {
            this.setState({
              isModalLoader: false,
              cEmailError: t('modal.error.unknow_error'),
            });
          }
        });
    });
  }

  validation() {
    const { useSMTP, checkMsg, serverURL } = this.state;
    const { t } = this.props;

    const data = {
      username: this.username.value,
      password: this.password.value,
      from: this.from.value,
      domain: this.domain.value,
      address: this.host.value,
      port: this.port.value,
      authentication: this.authentication.value,
      enable_starttls_auto: this.enableStarttlsAuto.value,
    };

    if (this.props.state.company.baseUrl !== serverURL && checkMsg !== 'Verified') {
      this.setState({
        modalAlert: true,
        modalAlertTitle: t('modal.title.attention'),
        modalAlertMsg: t('modal.error.check_base_url'),
      });
      return false;
    }

    if (useSMTP === 'off') {
      return true;
    }

    if (data.authentication !== 'none') {
      if (data.username === '') {
        this.setState({
          nickNameError: true,
        });
        return false;
      }
      if (data.password === '') {
        this.setState({
          passwordError: true,
        });
        return false;
      }
    }

    if (data.from === '') {
      this.setState({
        addressError: true,
      });
      return false;
    }

    if (data.domain === '') {
      this.setState({
        domainError: true,
      });
      return false;
    }

    if (data.address === '') {
      this.setState({
        hostError: true,
      });
      return false;
    }

    if (data.port === '') {
      this.setState({
        portError: true,
      });
      return false;
    }
    return true;
  }

  saveEmailInfo() {
    const { useSMTP } = this.state;
    const data = {
      from: this.from.value,
      domain: this.domain.value,
      address: this.host.value,
      port: this.port.value,
      authentication: this.authentication.value,
      enable_starttls_auto: this.enableStarttlsAuto.value,
    };

    if (data.authentication !== 'none') {
      data.username = this.username.value;
      data.password = this.password.value;
    }

    if (!this.validation()) {
      return;
    }

    if (useSMTP === 'on') {
      this.updateSmtp(true);
    } else {
      this.updateSmtp(false);
      return;
    }

    this.setState({
      isModalLoader: true,
    }, () => {
      api
        .saveMailer(data)
        .then(() => {
          this.setState({
            isModalLoader: false,
            isModalOpen: false,
            baseUrlError: false,
            modalAlert: false,
            nickNameError: false,
            passwordError: false,
            addressError: false,
            domainError: false,
            hostError: false,
            portError: false,
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isModalLoader: false,
            isModalOpen: false,
          });
        });
    });
  }

  render() {
    const {
      isIpSaving,
      useSMTP,
      isSmtpLoading,
      isAddrLoading,
    } = this.state;
    const { t } = this.props;

    const renderIfReady = (element) => {
      return !isSmtpLoading ? (
        element
      ) : (
        <Loader size="big" style={{ display: 'block', lineHeight: '25px' }}>
          {t('modal.message.loading')}
        </Loader>
      );
    };

    return (
      <div>
        <div className="content">
          <div className="setting_small_box">
            <h2 className="page_title">{t('system.title.smtp_settings')}</h2>
            {
              renderIfReady(
                <div className="setting_contnets">
                  <div className="setting_contnet_wrap">
                    <div className="left_content">
                      <h3 className="setting_content_title">{t('system.title.enable_smtp_usage')}</h3>
                      <div className="setting_content">
                        <select
                          value={this.state.useSMTP}
                          onChange={this.handleUseSMTP}
                        >
                          <option value="on">{t('system.button.on_uppercase')}</option>
                          <option value="off">{t('system.button.off_uppercase')}</option>
                        </select>
                      </div>
                    </div>
                    <div className="right_content">
                      <h3 className="setting_content_title">{t('modal.title.base_url')}</h3>
                      {
                        isAddrLoading ? (
                          <div style={{ marginTop: '11px' }}>
                            <Loader size="medium" active={isAddrLoading} inline="centered" />
                          </div>
                        ) : (
                          <div className="setting_content">
                            <table className="table">
                              <colgroup>
                                <col style={{ width: '92px' }} />
                                <col style={{ width: '' }} />
                                <col style={{ width: '72px' }} />
                              </colgroup>
                              <tbody>
                                <tr>
                                  <td>
                                    <select
                                      ref={(ref) => {
                                        this.protocol = ref;
                                      }}
                                      value={this.props.state.company.protocol}
                                      onChange={this.changeProtocol}
                                    >
                                      <option>http://</option>
                                      <option>https://</option>
                                    </select>
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      value={this.props.state.company.baseUrl}
                                      ref={(ref) => {
                                        this.baseUrl = ref;
                                      }}
                                      placeholder={t('modal.message.ip_address_placeholder')}
                                      onChange={this.handleBaseUrlChange}
                                    />
                                    {this.state.checkMsg === 'Failed' ? (
                                      <div
                                        className={cx('error', {
                                          show: this.state.baseUrlError,
                                        })}
                                      >
                                        {this.state.checkMsg}
                                      </div>
                                    ) : (
                                      <div
                                        className={cx('verified', {
                                          show: this.state.baseUrlError,
                                        })}
                                      >
                                        {this.state.checkMsg}
                                      </div>
                                    )}
                                  </td>
                                  <td>
                                    {isIpSaving ? (
                                      <img
                                        src={progress}
                                        role="presentation"
                                        style={{
                                          width: 14,
                                          height: 14,
                                          margin: '5px 0 0 15px',
                                        }}
                                        alt=""
                                      />
                                    ) : (
                                      <a
                                        className="gray_button"
                                        onClick={this.serverAddress}
                                        style={{ cursor: 'pointer' }}
                                      >
                                        {t('modal.button.check')}
                                      </a>
                                    )}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        )
                      }
                    </div>
                  </div>
                  <div className="setting_contnet_wrap">
                    <div
                      className={cx('left_content', {
                        disable: useSMTP === 'off',
                      })}
                    >
                      <h3 className="setting_content_title">{t('modal.title.domain')}</h3>
                      <div className="setting_content">
                        <input
                          type="text"
                          className="setting_input"
                          ref={(ref) => {
                            this.domain = ref;
                          }}
                          value={this.props.state.company.domain}
                          placeholder={`${t('system.list.example')} insignary.com`}
                          onChange={this.handleDomainChange}
                          disabled={this.state.useSMTP === 'off'}
                        />
                        <div className={cx('error', { show: this.state.domainError })}>
                          {t('modal.error.domain_required')}
                        </div>
                      </div>
                    </div>
                    <div
                      className={cx('right_content', {
                        disable:
                          useSMTP === 'off' || this.props.state.company.authentication === 'none',
                      })}
                    >
                      <h3 className="setting_content_title">{t('modal.title.user_name')}</h3>
                      <div className="setting_content">
                        <input
                          type="text"
                          className="setting_input"
                          value={this.props.state.company.nickName}
                          placeholder={`${t('system.list.example')} no-reply@insignary.com`}
                          ref={(ref) => {
                            this.username = ref;
                          }}
                          disabled={
                            this.props.state.company.authentication === 'none'
                            || this.state.useSMTP === 'off'
                          }
                          onChange={this.handleNickNameChange}
                        />
                        <div
                          className={cx('error', {
                            show: this.state.nickNameError,
                          })}
                        >
                          {t('modal.error.user_name_required')}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="setting_contnet_wrap">
                    <div
                      className={cx('left_content', {
                        disable: useSMTP === 'off',
                      })}
                    >
                      <h3 className="setting_content_title">{t('modal.title.host')}</h3>
                      <div className="setting_content">
                        <input
                          type="text"
                          className="setting_input"
                          value={this.props.state.company.host}
                          placeholder={`${t('system.list.example')} smtp.office365.com`}
                          ref={(ref) => {
                            this.host = ref;
                          }}
                          onChange={this.handleHostChange}
                          disabled={this.state.useSMTP === 'off'}
                          autoComplete="new-password"
                        />
                        <div className={cx('error', { show: this.state.hostError })}>
                          {t('modal.error.host_is_required')}
                        </div>
                      </div>
                    </div>
                    <div
                      className={cx('right_content', {
                        disable:
                          useSMTP === 'off' || this.props.state.company.authentication === 'none',
                      })}
                    >
                      <h3 className="setting_content_title">{t('modal.title.password')}</h3>
                      <div className="setting_content">
                        <input
                          type="password"
                          className="setting_input"
                          value={this.props.state.company.password}
                          placeholder={t('modal.message.smtp_placeholder')}
                          ref={(ref) => {
                            this.password = ref;
                          }}
                          onChange={this.handlePWChange}
                          disabled={
                            this.props.state.company.authentication === 'none'
                            || this.state.useSMTP === 'off'
                          }
                          autoComplete="new-password"
                        />
                        <div
                          className={cx('error', {
                            show: this.state.passwordError,
                          })}
                        >
                          {t('modal.error.password_required')}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="setting_contnet_wrap">
                    <div
                      className={cx('left_content', {
                        disable: useSMTP === 'off',
                      })}
                    >
                      <h3 className="setting_content_title">{t('modal.title.port')}</h3>
                      <div className="setting_content">
                        <input
                          type="text"
                          value={this.props.state.company.port}
                          placeholder={`${t('system.list.example')} 587`}
                          ref={(ref) => {
                            this.port = ref;
                          }}
                          onChange={this.handlePortChange}
                          disabled={this.state.useSMTP === 'off'}
                        />
                        <div className={cx('error', { show: this.state.portError })}>
                          {t('modal.error.port_required')}
                        </div>
                      </div>
                    </div>
                    <div
                      className={cx('right_content', {
                        disable: useSMTP === 'off',
                      })}
                    >
                      <h3 className="setting_content_title">{t('modal.title.from')}</h3>
                      <div className="setting_content">
                        <input
                          type="text"
                          value={this.props.state.company.address}
                          placeholder={`${t('system.list.example')} no-reply@insignary.com`}
                          ref={(ref) => {
                            this.from = ref;
                          }}
                          onChange={this.handleAddressChange}
                          disabled={this.state.useSMTP === 'off'}
                        />
                        <div className={cx('error', { show: this.state.addressError })}>
                          {t('modal.error.from_required')}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="setting_contnet_wrap">
                    <div
                      className={cx('left_content', {
                        disable: useSMTP === 'off',
                      })}
                    >
                      <div className="left_content">
                        <h3 className="setting_content_title">{t('modal.title.authentication')}</h3>
                        <div className="setting_content">
                          <select
                            disabled={this.state.useSMTP === 'off'}
                            ref={(ref) => {
                              this.authentication = ref;
                            }}
                            value={this.props.state.company.authentication}
                            onChange={this.handleAuthenticationChange}
                          >
                            <option value="login">{t('modal.title.login')}</option>
                            <option value="plain">{t('modal.title.plain')}</option>
                            <option value="none">{t('modal.title.none')}</option>
                          </select>
                        </div>
                      </div>
                      <div className="right_content">
                        <h3 className="setting_content_title">{t('modal.title.start_tls')}</h3>
                        <div className="setting_content">
                          <select
                            disabled={this.state.useSMTP === 'off'}
                            ref={(ref) => {
                              this.enableStarttlsAuto = ref;
                            }}
                            value={this.props.state.company.enable_starttls_auto}
                            onChange={this.handleEnableStarttlsAutoChange}
                          >
                            <option value="true">{t('modal.title.true')}</option>
                            <option value="false">{t('modal.title.false')}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }
            <div className="setting_bottom">
              {
                useSMTP === 'on' ? (
                  <a className="" onClick={this.handleSendEmail} style={{ cursor: 'pointer' }}>
                    {t('system.title.send_test_email')}
                  </a>
                ) : (
                  <a style={{ opacity: '0.4', pointerEvents: 'none' }}>
                    {t('system.title.send_test_email')}
                  </a>
                )
              }
              <a className="save" onClick={this.handleSave} style={{ cursor: 'pointer' }}>
                {t('modal.button.save')}
              </a>
            </div>
          </div>
        </div>
        <Modal
          open={this.state.isSendEmailModal}
          //onClose={this.closeModal}

        >
          {this.state.isModalLoader ? (
            <ClarLoader />
          ) : (
            <div className="modal_popup_wrap confirm_wrap">
              <div className="modal_popup_box confirm_box">
                <div className="modal_popup confirm">
                  <h2 className="title">{t('system.title.send_test_email')}</h2>
                  <p className="text">
                    <input
                      className="to"
                      ref={(ref) => {
                        this.to = ref;
                      }}
                      type="email"
                      placeholder={t('system.title.enter_email_address')}
                    />
                    <div style={{ fontSize: 13, color: 'red' }}>{this.state.cEmailError}</div>
                  </p>
                  <p className="small_text">{t('system.title.enter_email_address')}</p>
                  <div className="button_wrap">
                    <a onClick={this.closeModal} className="left_button">
                      {t('modal.button.cancel')}
                    </a>
                    <a onClick={this.sendEmail} className="right_button">
                      {t('modal.button.send')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal>
        <Modal open={this.state.isModalOpen} onClose={this.closeModal}>
          {
            this.state.isModalLoader ? (
              <ClarLoader />
            ) : (
              <div className="modal_popup_wrap confirm_wrap">
                <div className="modal_popup_box confirm_box">
                  <div className="modal_popup confirm">
                    <h2 className="title">{t('modal.title.attention')}</h2>
                    <p className="text">{this.modalBody}</p>
                    <div className="button_wrap">
                      <a onClick={this.closeModal} className="left_button">
                        {t('modal.button.no')}
                      </a>
                      <a onClick={this.saveEmailInfo} className="right_button">
                        {t('modal.button.yes')}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            )
          }
        </Modal>
        <Modal open={this.state.modalAlert} onClose={this.handleCloseAlert}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{this.state.modalAlertTitle}</h2>
                <p className="text">{this.state.modalAlertMsg}</p>
                <div className="button_wrap">
                  <a onClick={this.handleCloseAlert} className="center_button">
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(SMTPSystem))));
